/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateShiftAreaData
 */
export interface CreateShiftAreaData {
    /**
     * 
     * @type {string}
     * @memberof CreateShiftAreaData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftAreaData
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftAreaData
     */
    colour?: string;
    /**
     * The status of the entity.
     * @type {string}
     * @memberof CreateShiftAreaData
     */
    status: CreateShiftAreaDataStatusEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateShiftAreaData
     */
    locationIds: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum CreateShiftAreaDataStatusEnum {
    Active = 'Active',
    Archived = 'Archived',
    Deleted = 'Deleted'
}


/**
 * Check if a given object implements the CreateShiftAreaData interface.
 */
export function instanceOfCreateShiftAreaData(value: object): value is CreateShiftAreaData {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('locationIds' in value) || value['locationIds'] === undefined) return false;
    return true;
}

export function CreateShiftAreaDataFromJSON(json: any): CreateShiftAreaData {
    return CreateShiftAreaDataFromJSONTyped(json, false);
}

export function CreateShiftAreaDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateShiftAreaData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'colour': json['colour'] == null ? undefined : json['colour'],
        'status': json['status'],
        'locationIds': json['locationIds'],
    };
}

  export function CreateShiftAreaDataToJSON(json: any): CreateShiftAreaData {
      return CreateShiftAreaDataToJSONTyped(json, false);
  }

  export function CreateShiftAreaDataToJSONTyped(value?: CreateShiftAreaData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'colour': value['colour'],
        'status': value['status'],
        'locationIds': value['locationIds'],
    };
}

